import axios from 'axios'

export default {
  getAvailableStations: (regionId) => axios.get(`/api/v1/widgets/${regionId}/available-stations`),
  getAllWidgets: (regionId) => axios.get(`/api/v1/widgets/region/${regionId}`),
  getPreview: (stationId) => axios.get(`api/v1/widgets/preview/${stationId}`),
  createWidget: (regionId, data) => axios.post(`/api/v1/widgets/${regionId}`, data),
  deleteWidget: (widgetId) => axios.delete(`/api/v1/widgets/${widgetId}`),
  updateWidget: (widgetId, regionId, data) => axios.put(`/api/v1/widgets/${regionId}/${widgetId}`, data),
  activateWidget: (widgetId) => axios.put(`/api/v1/widgets/${widgetId}/activate`),
  deactivateWidget: (widgetId) => axios.put(`/api/v1/widgets/${widgetId}/deactivate`),
  duplicateWidget: (data) => axios.post('/api/v1/widgets', data),
  getStationWidgetsAccess: (stationId) => axios.get(`/api/v1/widgets/access/station/${stationId}`)
}
